import { CommandProps, Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { BlockTypes, FileBlockDataItem } from '../../../../models';
import { FileNodeView } from './FileNodeView';

interface FileProps {
  items: FileBlockDataItem[];
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    fileNode: { insertFileNode: ({ items }: FileProps) => ReturnType };
  }
}

export const FileNode = Node.create({
  name: 'fileNode',
  group: 'block',
  atom: true,

  addAttributes() {
    return { items: [], pastedFiles: [] };
  },

  parseHTML() {
    return [{ tag: BlockTypes.file }];
  },

  renderHTML({ HTMLAttributes }) {
    return [BlockTypes.file, mergeAttributes(HTMLAttributes)];
  },

  addCommands() {
    return {
      insertFileNode:
        ({ items }: FileProps) =>
        ({ commands }: CommandProps) => {
          return commands.insertContent({ type: this.name, attrs: { items } });
        },
    };
  },

  addNodeView() {
    return ReactNodeViewRenderer(FileNodeView);
  },
});
